import {getWxAuth, getActClick, actClickList} from "../../base/api/getActivityInfo";
export async function doGetWxAuth(param) {
    let data;
    try {
        let params = param;
        data = await getWxAuth(params);
        if (data.data.code == "0000") {
            let result = data.data.data;
            return {
                hasError: false,
                info: result
            };
        } else if (data.data.code == "4001") {
            // 4001 说明授权过期，需要重新授权
            localStorage.removeItem("wxCode");
            window.location.reload();
        } else {
            window.globalVue.$Toast({
                message: data.data.msg
            });
            return {
                hasError: true
            };
        }
    } catch (error) {
        window.globalVue.$Toast({
            message: "请求出错"
        });
        return {
            hasError: true
        };
    }
}

export async function doGetActClick(param) {
    let data;
    try {
        let params = param;
        data = await getActClick(params);
        if (data.data.code == "0000") {
            return {
                hasError: false,
                info: data.data.data
            };
        } else if (data.data.code == "0002") {
            window.globalVue.$Toast({
                message: data.data.msg
            });
            window.globalVue.$Indicator.close();
        } else {
            window.globalVue.$Toast({
                message: data.data.msg
            });
            return {
                hasError: true
            };
        }
    } catch (error) {
        window.globalVue.$Toast({
            message: "请求出错"
        });
        return {
            hasError: true
        };
    }
}

export async function getActClickList(param) {
    let data;
    try {
        let params = param;
        data = await actClickList(params);
        if (data.data.code == "0000") {
            let result = data.data.data;
            return {
                hasError: false,
                hasClick: result.click == 2 ? true : false,
                isRegister: result.userInfo ? false : true,
                userInfo: result.userInfo,
                shareInfo: result.attr_info,
                hasRewards: result.attr_info ? true : false
            };
        } else {
            window.globalVue.$Toast({
                message: data.data.msg
            });
            return {
                hasError: true
            };
        }
    } catch (error) {
        window.globalVue.$Toast({
            message: "请求出错"
        });
        return {
            hasError: true
        };
    }
}